import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { LuX, LuChevronDown, LuChevronRight } from "react-icons/lu";

const emptyPermissions = {
  dashboard: {
    isAllPermission: false,
    permissions: { view: false },
  },
  roleManagement: {
    isAllPermission: false,
    permissions: { view: false, create: false, edit: false, delete: false },
  },

  staffManagement: {
    isAllPermission: false,
    permissions: { view: false, create: false, edit: false, delete: false },
  },
  staffWalletManagement: {
    isAllPermission: false,
    permissions: { view: false, create: false, edit: false, delete: false },
  },
  users: {
    isAllPermission: false,
    subModule: {
      user: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      Traffic: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      CallHistory: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      MessageHistory: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      CoinHistory: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      Recharge: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      Avatar: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      BlockUser: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
    },
  },

  payout: {
    isAllPermission: false,
    subModule: {
      kyc: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      approve: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      wallet: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      manualWithdrawal: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
    },
  },

  coinManagement: {
    isAllPermission: false,
    subModule: {
      manageCoins: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      manageGifts: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      promocode: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      coinPromocode: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      couponcode: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
    },
  },

  Notifications: {
    isAllPermission: false,
    subModule: {
      single: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      bulk: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      banner: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
    },
  },

  userRequests: {
    isAllPermission: false,
    subModule: {
      accDeleteReq: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      groupReq: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      nameChangeReq: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      masti: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
    },
  },

  appFeedback: {
    isAllPermission: false,
    permissions: { view: false, create: false, edit: false, delete: false },
  },
  gangRankings: {
    isAllPermission: false,
    subModule: {
      gangTarget: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      gangSummary: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
      gangLevelConfig: {
        isAllPermission: false,
        permissions: { view: false, create: false, edit: false, delete: false },
      },
    },
  },
  staffActivity: {
    isAllPermission: false,
    permissions: { view: false, create: false, edit: false, delete: false },
  },
  events: {
    isAllPermission: false,
    permissions: { view: false, create: false, edit: false, delete: false },
  },
  appVersion: {
    isAllPermission: false,
    permissions: { view: false, create: false, edit: false, delete: false },
  },
};

function CreateEditRole({ open, onClose, editData, refreshList }) {
  const [roleName, setRoleName] = useState("");
  const [permissions, setPermissions] = useState(emptyPermissions);
  const [expandedModules, setExpandedModules] = useState({});
  const [expandedSubModules, setExpandedSubModules] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  // RESET DROPDOWNS + ROLE WHEN MODAL CLOSES
  useEffect(() => {
    if (open) {
      setExpandedModules({});
      setExpandedSubModules({});

      if (editData) {
        setIsEdit(true);
        setRoleName(editData.rolename || "");
        setPermissions(
          mergePermissions(emptyPermissions, editData.permission || {})
        );
      } else {
        setIsEdit(false);
        setRoleName("");
        setPermissions(emptyPermissions);
      }
    }
  }, [open, editData]);

  if (!open) return null;

  const mergePermissions = (defaultPerms, savedPerms) => {
    const output = structuredClone(defaultPerms);

    const deepMerge = (target, source) => {
      for (const key in source) {
        if (
          source[key] &&
          typeof source[key] === "object" &&
          !Array.isArray(source[key])
        ) {
          if (!target[key]) target[key] = {};
          deepMerge(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    };

    deepMerge(output, savedPerms);
    return output;
  };

  const toggleCheckbox = (pathArray, value) => {
    const updated = structuredClone(permissions);
    let obj = updated;

    for (let i = 0; i < pathArray.length - 1; i++) {
      obj = obj[pathArray[i]];
    }

    obj[pathArray[pathArray.length - 1]] = value;
    setPermissions(updated);
  };

  const toggleModule = (key) => {
    setExpandedModules((prev) => {
      const newState = {};
      Object.keys(prev).forEach((k) => {
        newState[k] = k === key ? !prev[k] : false;
      });
      if (!prev[key]) newState[key] = true;
      return newState;
    });
    setExpandedSubModules({});
  };

  const toggleSubModule = (moduleKey, subKey) => {
    const id = `${moduleKey}-${subKey}`;
    setExpandedSubModules((prev) => {
      const newState = {};
      Object.keys(prev).forEach((k) => {
        newState[k] = k === id ? !prev[k] : false;
      });
      if (!prev[id]) newState[id] = true;
      return newState;
    });
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  // -------------------------------------
  // SAVE OR UPDATE ROLE
  // -------------------------------------
  const handleSubmit = async () => {
    if (!roleName.trim()) {
      return Swal.fire({
        icon: "warning",
        title: "Role name required!",
      });
    }

    const payload = {
      rolename: roleName,
      permission: permissions,
    };

    Swal.fire({
      title: isEdit ? "Updating role..." : "Creating role...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const url = isEdit
        ? `${process.env.REACT_APP_API_URL}/role-permission/update-role/${editData._id}`
        : `${process.env.REACT_APP_API_URL}/role-permission/create-role`;

      const method = isEdit ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      Swal.close();

      if (!data.success) {
        return Swal.fire({
          icon: "error",
          title: data.message || "Operation failed",
        });
      }

      Swal.fire({
        icon: "success",
        title: isEdit
          ? "Role Updated Successfully!"
          : "Role Created Successfully!",
        timer: 1500,
        showConfirmButton: false,
      });

      onClose();
      refreshList();
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: error.message,
      });
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#000]/40 bg-opacity-40 p-3 backdrop-blur-sm"
      onClick={handleBackdropClick}
    >
      <div className="max-h-[90vh] w-full max-w-[45rem] overflow-hidden rounded-xl bg-white shadow-2xl">
        {/* HEADER */}
        <div className="flex items-center justify-between border-b px-6 py-4">
          <h2 className="text-xl font-bold text-gray-800 sm:text-2xl">
            {isEdit ? "Edit Role" : "Create New Role"}
          </h2>
          <button
            onClick={onClose}
            className="rounded-lg p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <LuX size={24} />
          </button>
        </div>

        {/* BODY */}
        <div
          className="overflow-y-auto p-4 sm:p-6"
          style={{ maxHeight: "calc(90vh - 140px)" }}
        >
          {/* Role Name */}
          <div className="mb-6">
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Role Name
            </label>
            <input
              type="text"
              placeholder="Enter role name"
              className="w-full rounded-lg border px-4 py-2.5 text-sm focus:border-[#c51369] focus:ring-2 focus:ring-[#c51369] focus:ring-opacity-20"
              value={roleName}
              onChange={(e) => setRoleName(e.target.value)}
            />
          </div>

          {/* PERMISSIONS */}
          <div className="mb-4">
            <label className="mb-3 block text-sm font-medium text-gray-700">
              Permissions
            </label>

            <div className="space-y-3">
              {Object.keys(permissions).map((moduleKey) => {
                const module = permissions[moduleKey];
                const isExpanded = expandedModules[moduleKey];

                return (
                  <div
                    key={moduleKey}
                    className="overflow-hidden rounded-lg border bg-gray-50"
                  >
                    {/* Module Header */}
                    <div
                      className="flex cursor-pointer items-center justify-between bg-gray-100 px-4 py-3"
                      onClick={() => toggleModule(moduleKey)}
                    >
                      <div className="flex items-center gap-2">
                        {isExpanded ? (
                          <LuChevronDown size={20} />
                        ) : (
                          <LuChevronRight size={20} />
                        )}
                        <h3 className="text-base font-semibold capitalize">
                          {moduleKey}
                        </h3>
                      </div>
                    </div>

                    {isExpanded && (
                      <div className="bg-white p-4">
                        {/* Direct permissions */}
                        {module.permissions && (
                          <div className="mb-4">
                            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
                              {Object.keys(module.permissions).map((perm) => (
                                <label
                                  key={perm}
                                  className="flex items-center gap-2 rounded-md border bg-gray-50 px-3 py-2"
                                >
                                  <input
                                    type="checkbox"
                                    checked={module.permissions[perm]}
                                    onChange={(e) =>
                                      toggleCheckbox(
                                        [moduleKey, "permissions", perm],
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <span className="text-sm capitalize">
                                    {perm}
                                  </span>
                                </label>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Submodules */}
                        {module.subModule &&
                          Object.keys(module.subModule).map((subKey) => {
                            const sub = module.subModule[subKey];
                            const id = `${moduleKey}-${subKey}`;
                            const isSubExpanded = expandedSubModules[id];

                            return (
                              <div
                                key={subKey}
                                className="mb-2 overflow-hidden rounded-lg border"
                              >
                                <div
                                  className="flex cursor-pointer items-center gap-2 bg-blue-50 px-3 py-2.5"
                                  onClick={() =>
                                    toggleSubModule(moduleKey, subKey)
                                  }
                                >
                                  {isSubExpanded ? (
                                    <LuChevronDown size={18} />
                                  ) : (
                                    <LuChevronRight size={18} />
                                  )}
                                  <h4 className="text-sm font-semibold capitalize">
                                    {subKey}
                                  </h4>
                                </div>

                                {isSubExpanded && (
                                  <div className="bg-white p-3">
                                    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
                                      {Object.keys(sub.permissions).map(
                                        (perm) => (
                                          <label
                                            key={perm}
                                            className="flex items-center gap-2 rounded-md border bg-gray-50 px-3 py-2"
                                          >
                                            <input
                                              type="checkbox"
                                              checked={sub.permissions[perm]}
                                              onChange={(e) =>
                                                toggleCheckbox(
                                                  [
                                                    moduleKey,
                                                    "subModule",
                                                    subKey,
                                                    "permissions",
                                                    perm,
                                                  ],
                                                  e.target.checked
                                                )
                                              }
                                            />
                                            <span className="text-sm capitalize">
                                              {perm}
                                            </span>
                                          </label>
                                        )
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4">
          <button onClick={onClose} className="rounded-lg bg-white px-6 py-2.5">
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="rounded-lg bg-[#c51369] px-6 py-2.5 text-white"
          >
            {isEdit ? "Update Role" : "Save Role"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateEditRole;
